import type { WebSocketEvent } from '@zg-rentals/web-socket-react';

const SATELLITE_EVENT_TYPES = new Set(['conversationUpdated', 'newConversation', 'newMessage']);

/**
 * Satellite-specific WebSocket event with conversation messaging fields.
 * Use `isSatelliteWebSocketEvent` to narrow a generic `WebSocketEvent` safely.
 *
 * @example
 * if (isSatelliteWebSocketEvent(message.event)) {
 *   console.log(message.event.conversationId, message.event.messageId);
 * }
 */
export type SatelliteWebSocketEvent = WebSocketEvent & {
  type: 'conversationUpdated' | 'newConversation' | 'newMessage';
  conversationId?: string;
  messageId?: string;
  createdAtMs?: number;
  lastMessageAtMs?: number;
};

/** Runtime type guard for `SatelliteWebSocketEvent`. Checks that `type` is one of the known Satellite event types. */
export const isSatelliteWebSocketEvent = (event: unknown): event is SatelliteWebSocketEvent =>
  event != null &&
  typeof event === 'object' &&
  'type' in event &&
  typeof (event as { type: unknown }).type === 'string' &&
  SATELLITE_EVENT_TYPES.has((event as { type: string }).type);
